import styled from 'styled-components';

// A fixed slot the width of a small icon so unchecked rows keep their
// circles and labels aligned with checked ones.
const CheckSlot = styled.span`
  display: flex;
  width: 16px;
  height: 16px;
  align-items: center;
  justify-content: center;
`;

export { CheckSlot };
